var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgProfileIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 30,
    height: 30,
    viewBox: "0 0 40 40",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Profile_icon",
    "data-name": "Profile icon",
    d: "M11.1,35.25a28.442,28.442,0,0,1,6.225-3.025A20.988,20.988,0,0,1,24,31.2a21.219,21.219,0,0,1,6.7,1.025,28.243,28.243,0,0,1,6.25,3.025,17.553,17.553,0,0,0,3.125-5.45A18.071,18.071,0,0,0,41,24,16.657,16.657,0,0,0,24,7,16.657,16.657,0,0,0,7,24a17.637,17.637,0,0,0,.95,5.8A17.994,17.994,0,0,0,11.1,35.25ZM24,25.5a6.746,6.746,0,0,1-6.85-6.85A6.746,6.746,0,0,1,24,11.8a6.746,6.746,0,0,1,6.85,6.85A6.746,6.746,0,0,1,24,25.5ZM24,44a19.6,19.6,0,0,1-7.85-1.575A19.9,19.9,0,0,1,5.55,31.75,19.746,19.746,0,0,1,4,23.95,19.352,19.352,0,0,1,5.575,16.2a19.988,19.988,0,0,1,4.3-6.35A20.5,20.5,0,0,1,16.25,5.575a19.978,19.978,0,0,1,15.55,0A19.969,19.969,0,0,1,42.425,16.2a19.978,19.978,0,0,1,0,15.55,20.5,20.5,0,0,1-4.275,6.375,19.988,19.988,0,0,1-6.35,4.3A19.475,19.475,0,0,1,24,44Z",
    transform: "translate(-4 -4)",
    fill: "rgba(0,0,0,0.38)"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgProfileIcon);
export default __webpack_public_path__ + "static/media/Profile-icon.55dd788f13d3df7f2b944bd80e40c9db.svg";
export { ForwardRef as ReactComponent };